/**
 * @generated SignedSource<<e68874ed3c4e343fd5635e63651d9f8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotesCastPanelFragment$data = {
  readonly number: string;
  readonly " $fragmentSpreads": FragmentRefs<"CastVoteInputFragment" | "CastVoteInputVoteButtonsFragment" | "ProposalVotesSummaryFragment">;
  readonly " $fragmentType": "VotesCastPanelFragment";
};
export type VotesCastPanelFragment$key = {
  readonly " $data"?: VotesCastPanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VotesCastPanelFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VotesCastPanelFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProposalVotesSummaryFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CastVoteInputFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CastVoteInputVoteButtonsFragment"
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};

(node as any).hash = "e5ff15ee98c3139ac0b6be65c357f1a0";

export default node;
